import React from 'react';

import { bemCssModules } from '@utils';

import style from './SupportLink.scss';

const cn = bemCssModules(style, 'SupportLink');

export type TSupportLink = React.JSX.IntrinsicElements['a'];

const SupportLink: CustomFC<TSupportLink> = ({ className, ...rest }) => (
  <a href="mailto:support@mercuryo.io" className={cn(null, [className, 'link'])} {...rest}>
    support@mercuryo.io
  </a>
);

export default SupportLink;
